<template>
  <div class="billsReceivable">
    <van-form
      label-width="120px"
      :show-error="false"
      :scroll-to-error="false"
      @submit="onSubmit"
    >
      <div class="title">DEBIT NOTE</div>

      <van-field
        v-model="customerInfoSelect.text"
        label="Customer Name:"
        :placeholder="!isEdit ? '' : $t.meta.input"
        @click="onShowEmit(0, 'showBillsReceivableCustomer')"
        clickable
        readonly
        required
        :rules="formRule"
      />
      <van-field
        v-model="customerInfoSelect.CustomerNumber"
        label="Customer No:"
        disabled
      />

      <van-field
        v-model="billInfo.PWB_Number"
        v-if="billInfo.PWB_Number"
        label="Master B/L No:"
        disabled
      />
      <van-field
        v-model="billInfo.EtdDate"
        label="Etd/Eta.:"
        v-if="billInfo.EtdDate"
        disabled
      />
      <van-field
        v-model="billInfo.WB_Number"
        label="Way Bill No:"
        v-if="billInfo.WB_Number"
        disabled
      />

      <van-field
        v-model="billInfo.CurrentTime"
        label="Date:"
        v-if="billInfo.CurrentTime"
        disabled
      />
      <van-field v-model="billInfo.InvoiceNo" label="Invoice No.:" disabled />
      <van-field
        v-model="billInfo.AllWeight"
        label="Weight:"
        v-if="billInfo.AllWeight"
        disabled
      />
      <van-field v-model="billInfo.POL" label="POL" v-if="billInfo.POL" disabled />
      <van-field v-model="billInfo.POD" label="POD" v-if="billInfo.POD" disabled />

      <div class="multi-table" v-if="form.itemList">
        <van-field name="stepper" :label="$t.meta.chagreTitle" required>
          <template #input>
            <van-stepper
              :min="0"
              :value="form.itemList.length"
              @minus="handleItemDel"
              @plus="handleItemAdd"
              :disable-input="true"
              :disabled="!isEdit ? true : false"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in form.itemList" :key="index">
          <div class="multi-table-header">
            <div class="multi-table-title">No.{{ index + 1 }}</div>
            <div
              class="multi-table-btn"
              @click="handleItemDelByIndex(index)"
              v-if="isEdit"
            >
              <van-icon name="close" />
            </div>
          </div>
          <van-field
            v-model="item.BillName"
            :label="$t.billsReceivable.project"
            label-class="number-label"
            @click="onShowEmit(index, 'showBillsReceivableItem')"
            :placeholder="!isEdit ? '' : $t.meta.select"
            :disabled="!isEdit ? true : false"
            clickable
            readonly
            required
            :rules="formRule"
          >
            <template #button>
              <van-button
                size="small"
                type="info"
                native-type="button"
                class="item-button"
                @click="gotoCreate"
                v-if="isEdit"
                >{{ $t.meta.add }}</van-button
              >
            </template>
          </van-field>
          <van-field
            v-model="item.CurrencySn"
            :label="$t.meta.currency"
            @click="pickerShow(index, 'showCurrencyPicker')"
            :placeholder="!isEdit ? '' : $t.meta.select"
            :disabled="!isEdit ? true : false"
            clickable
            readonly
            required
            :rules="formRule"
          />
          <van-field
            v-model="item.Quantity"
            :label="$t.billsReceivable.quantity"
            :placeholder="!isEdit ? '' : $t.meta.input"
            :disabled="!isEdit ? true : false"
            oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
            @blur="rateInputChange"
            clickable
            required
            :rules="formRule"
          />
          <van-field
            v-model="item.UnitPrice"
            :label="$t.billsReceivable.unitPrice"
            :placeholder="!isEdit ? '' : $t.meta.input"
            :disabled="!isEdit ? true : false"
            oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
            @blur="rateInputChange"
            clickable
            required
            :rules="formRule"
          />
          <van-field
            :value="(item.Quantity * item.UnitPrice).toFixed(2)"
            :label="$t.billsReceivable.total"
            readonly
          />
        </div>
      </div>

      <div class="multi-table" v-if="selectedAccountList">
        <van-field name="stepper" :label="$t.billsReceivable.bankAccount">
          <template #input>
            <van-stepper
              :min="0"
              :value="selectedAccountList.length"
              @minus="handleAccountDel"
              @plus="handleAccountAdd"
              :disable-input="true"
              :disabled="!isEdit ? true : false"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in selectedAccountList" :key="index">
          <div class="multi-table-header">
            <div class="multi-table-title">No.{{ index + 1 }}</div>
            <div
              class="multi-table-btn"
              @click="handleAccountDelByIndex(index)"
              v-if="isEdit"
            >
              <van-icon name="close" />
            </div>
          </div>
          <van-field
            v-model="item.AccountNickName"
            :label="$t.billsReceivable.accountName"
            @click="pickerShow(index, 'showAccountPicker')"
            :placeholder="!isEdit ? '' : $t.meta.select"
            :disabled="!isEdit ? true : false"
            clickable
            readonly
          />
          <van-field
            v-model="item.BankName"
            :label="$t.billsReceivable.bankName"
            type="textarea"
            rows="3"
            readonly
            disabled
            v-if="item.AccountId"
          />
          <van-field
            v-model="item.AccountNumber"
            :label="$t.billsReceivable.bankAccount"
            readonly
            disabled
            v-if="item.AccountId"
          />
          <van-field
            v-model="item.SwiftCode"
            label="Swift Code"
            readonly
            disabled
            v-if="item.AccountId"
          />
          <van-field
            v-model="item.Address"
            :label="$t.billsReceivable.address"
            type="textarea"
            rows="3"
            readonly
            disabled
            v-if="item.AccountId"
          />
        </div>
      </div>

      <van-field
        v-model="form.Remark"
        :label="$t.billsReceivable.remark"
        :placeholder="!isEdit ? '' : $t.meta.input"
        :disabled="!isEdit ? true : false"
        type="textarea"
        rows="5"
      />

      <div v-if="mergeCurrencyList.length > 0">
        <div class="title">{{ $t.billsReceivable.total }}</div>
        <van-field
          v-model="item.Rate"
          :label="item.CurrencySn"
          readonly
          v-for="(item, index) in mergeCurrencyList"
          :key="index"
        />
      </div>

      <div style="margin: 16px">
        <!-- 打印 -->
        <van-button
          round
          block
          type="default"
          style="margin-top: 10px"
          native-type="button"
          @click="gotoPrint"
        >
          {{ $t.meta.print }}
        </van-button>

        <!-- 发送邮件 -->
        <van-button
          round
          block
          type="default"
          style="margin-top: 10px"
          native-type="button"
          @click="dialogShowEmail"
        >
          {{ $t.billsReceivable.emailShare }}
        </van-button>
      </div>

      <div class="tool-bar" v-if="isEdit">
        <van-button type="info" block native-type="submit">{{ $t.meta.save }}</van-button>
      </div>
    </van-form>

    <fetch-list
      event="showBillsReceivableCustomer"
      type="customerManagement"
      request="getCustomerInfoSearchList"
      @onSelect="onSelectCustomer"
    ></fetch-list>

    <option-list
      event="showBillsReceivableItem"
      :options="billPaymentList"
      @onSelect="itemConfirm"
    ></option-list>

    <option-list
      event="showBillsReceivableEmail"
      :options="emailList"
      @onSelect="emailConfirm"
    ></option-list>

    <van-popup v-model="showCurrencyPicker" round position="bottom">
      <van-picker
        :title="$t.meta.currency"
        show-toolbar
        :columns="currencyList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="currencyConfirm"
        @cancel="showCurrencyPicker = false"
      />
    </van-popup>

    <van-popup v-model="showAccountPicker" round position="bottom">
      <van-picker
        :title="$t.billsReceivable.bankAccount"
        show-toolbar
        :columns="accountInfoList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="accountConfirm"
        @cancel="showAccountPicker = false"
      />
    </van-popup>

    <van-dialog
      :title="$t.billsReceivable.emailShare"
      width="90%"
      v-model="emailVisible"
      @cancel="emailVisible = false"
      @confirm="onSendEmail"
      :cancel-button-text="$t.meta.close"
      :confirm-button-text="$t.meta.confirm"
      :show-cancel-button="true"
      :show-confirm-button="true"
    >
      <slot name="default">
        <div class="billsReceivable-alert">
          <van-form label-width="80px">
            <van-field
              v-model="emailForm.email"
              :label="$t.billsReceivable.email"
              :placeholder="$t.billsReceivable.placeholderEmail"
              type="textarea"
              rows="5"
              required
            >
              <template #button>
                <van-button
                  size="small"
                  type="info"
                  native-type="button"
                  @click="onShowEmailEmit('showBillsReceivableEmail')"
                  >{{ $t.meta.search }}</van-button
                >
              </template>
            </van-field>
          </van-form>
        </div>
      </slot>
    </van-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import { Form, Field, Button, Uploader, Icon, Stepper, Popup, Picker } from "vant";

import FetchList from "@components/fetchList/FetchList.vue";
import OptionList from "@components/optionList/OptionList.vue";

Vue.use(Form)
  .use(Field)
  .use(Button)
  .use(Uploader)
  .use(Icon)
  .use(Stepper)
  .use(Popup)
  .use(Picker);

export default {
  name: "billsReceivable",
  components: {
    FetchList,
    OptionList,
  },
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      WGId: "",
      TOId: "",
      isEdit: true,
      form: {
        itemList: [
          {
            BillId: "",
            BillName: "",
            Currency: "",
            CurrencySn: "",
            Quantity: "",
            UnitPrice: "",
            Rate: "",
          },
        ],
        Remark: "",
      },
      formRule: [
        {
          required: true,
          message: this.$t.meta.require,
        },
      ],
      billInfo: {},
      InvoiceNo: "",
      PWB_Number: "",
      WB_Number: "",
      customerInfoSelect: { text: "", value: null, CustomerNumber: "" },
      currencyList: [],
      billPaymentList: [],
      accountInfoList: [],
      selectedAccountList: [
        {
          AccountName: "",
          AccountNickName: "",
          AccountId: null,
          BankName: "",
          AccountNumber: "",
          SwiftCode: "",
          Address: "",
        },
      ],
      itemIndex: 0,
      showCurrencyPicker: false,
      showAccountPicker: false,
      mergeCurrencyList: [],
      //发送邮件
      emailVisible: false,
      emailList: [],
      emailForm: {
        email: "",
      },
    };
  },
  created() {
    const { InvoiceNo, WB_Number, WGId, TOId, IsExternal } = this.$route.query;
    if (IsExternal) {
      this.isEdit = false;
    }
    if (InvoiceNo) {
      this.InvoiceNo = InvoiceNo;
      this.getOptions().then((success) => {
        if (success) {
          this.getCollectionBillDetails();
        }
      });
    } else {
      if (WB_Number) {
        this.WB_Number = WB_Number;
      }
      if (WGId) {
        this.WGId = WGId;
      }
      if (TOId) {
        this.TOId = TOId;
      }
      this.getOptions();
      this.loadWayBillInfo();
    }
  },
  methods: {
    gotoCreate() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "expenseNameManagementDetail",
        name: "expenseNameManagementDetail",
        query: [],
      });
    },
    getCollectionBillDetails() {
      this.$commonMethod.showLoading();
      this.$api.financialManagement
        .getCollectionBillDetails({
          CompanyId: this.CompanyId,
          InvoiceNo: this.InvoiceNo,
        })
        .then((res) => {
          this.billInfo = res.data;
          this.customerInfoSelect = {
            text: this.billInfo.CustomerName,
            value: this.billInfo.CustomerId,
            CustomerNumber: this.billInfo.CustomerNumber,
          };
          if (this.billInfo.ItemList && this.billInfo.ItemList.length > 0) {
            this.form.itemList = [];
            for (var item of this.billInfo.ItemList) {
              this.form.itemList.push({
                BillId: item.BillId,
                BillName: item.ItemName,
                Currency: item.Currency,
                CurrencySn: item.CurrencySn,
                Quantity: item.Quantity,
                UnitPrice: item.UnitPrice,
                Rate: item.Rate,
              });
            }
          }
          if (this.billInfo.AccountList && this.billInfo.AccountList.length > 0) {
            this.selectedAccountList = [];
            for (var item of this.billInfo.AccountList) {
              this.selectedAccountList.push({
                AccountNickName: item.AccountNickName,
                AccountName: item.AccountName,
                AccountId: item.AccountId,
                BankName: item.BankName,
                AccountNumber: item.AccountNumber,
                SwiftCode: item.SwiftCode,
                Address: item.Address,
              });
            }
          }
          this.form.Remark = this.billInfo.Remark;
          this.mergeCurrency();
          this.$commonMethod.fieldRefresh(".billsReceivable");
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    getOptions() {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        Promise.all([
          this.getBillPaymentList(),
          this.getCurrencyList(),
          this.getCollectionAccountInfoList(),
        ])
          .then((success) => {
            if (success) {
              resolve(true);
            }
            this.$commonMethod.hideLoading();
          })
          .catch(() => {
            this.$commonMethod.hideLoading();
          });
      });
    },
    mergeCurrency() {
      const test = this.form.itemList.map((item) => {
        const item2 = { ...item }; // 深拷贝，不然会影响原数组
        return item2;
      });
      for (let i in test) {
        test[i].Rate = test[i].Quantity * test[i].UnitPrice;
      }
      for (let i in this.form.itemList) {
        this.form.itemList[i].Rate =
          this.form.itemList[i].Quantity * this.form.itemList[i].UnitPrice;
      }
      const newArray = test.reduce((total, cur, index) => {
        const hasValue = total.findIndex((current) => {
          return current.Currency === cur.Currency;
        });
        hasValue === -1 && total.push(cur);
        hasValue !== -1 &&
          (total[hasValue].Rate = Number(total[hasValue].Rate) + Number(cur.Rate));
        return total;
      }, []);
      for (const i in newArray) {
        newArray[i].Rate = Number(newArray[i].Rate).toFixed(2);
      }
      this.mergeCurrencyList = newArray;
    },
    rateInputChange() {
      this.mergeCurrency();
    },
    handleAccountDelByIndex(index) {
      if (this.selectedAccountList.length > 0) {
        this.selectedAccountList.splice(index, 1);
      }
    },
    handleAccountDel() {
      if (this.selectedAccountList.length > 0) {
        this.selectedAccountList.pop();
      }
    },
    handleAccountAdd() {
      this.selectedAccountList.push({
        AccountNickName: "",
        AccountId: null,
      });
    },
    pickerShow(index, pickerName) {
      if (!this.isEdit) {
        return;
      }
      if (pickerName == "showAccountPicker") {
        if (this.accountInfoList.length == 0) {
          this.$commonMethod.customAlert(
            {
              message: this.$t.billsReceivable.noAccount,
              cancelButtonText: this.$t.alert.cancelButtonText,
              confirmButtonText: this.$t.meta.goToCreate,
            },
            () => {
              this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
                isParams: false,
                path: "receivingAccountManagementDetail",
                name: "receivingAccountManagementDetail",
                query: [],
              });
            },
            () => {}
          );
          return;
        }
      }
      this[pickerName] = true;
      this.itemIndex = index;
    },
    itemConfirm(item) {
      this.form.itemList[this.itemIndex].BillName = item.text;
      this.form.itemList[this.itemIndex].BillId = item.value;
    },
    currencyConfirm(e) {
      if (!e) {
        return;
      }
      this.form.itemList[this.itemIndex].CurrencySn = e.text;
      this.form.itemList[this.itemIndex].Currency = e.value;
      this.showCurrencyPicker = false;
      this.mergeCurrency();
    },
    accountConfirm(e) {
      if (!e) {
        return;
      }
      this.selectedAccountList[this.itemIndex].AccountNickName = e.text;
      this.selectedAccountList[this.itemIndex].AccountId = e.value;
      this.selectedAccountList[this.itemIndex].AccountName = e.AccountName;
      this.selectedAccountList[this.itemIndex].BankName = e.BankName;
      this.selectedAccountList[this.itemIndex].AccountNumber = e.AccountNumber;
      this.selectedAccountList[this.itemIndex].SwiftCode = e.SwiftCode;
      this.selectedAccountList[this.itemIndex].Address = e.Address;
      this.showAccountPicker = false;
    },
    emailConfirm(e) {
      this.emailForm.email = e.value;
    },
    handleItemDelByIndex(index) {
      if (this.form.itemList.length > 0) {
        this.form.itemList.splice(index, 1);
      }
      this.mergeCurrency();
    },
    handleItemDel() {
      if (this.form.itemList.length > 0) {
        this.form.itemList.pop();
      }
      this.mergeCurrency();
    },
    handleItemAdd() {
      this.form.itemList.push({
        BillId: "",
        BillName: "",
        Currency: "",
        CurrencySn: "",
        Quantity: "",
        UnitPrice: "",
        Rate: "",
      });
    },
    onSelectCustomer(item) {
      this.customerInfoSelect.text = item.text;
      this.customerInfoSelect.value = item.value;
      this.customerInfoSelect.CustomerNumber = item.CustomerNumber;
    },
    onShowEmailEmit(emit) {
      this.$commonMethod.showLoading();
      var param = {
        UserId: this.UserId,
      };
      this.$api.logisticsManagement
        .getUserInvoiceShareEmailHistoryList(param)
        .then((res) => {
          var result = [];
          res.data.forEach((item) => {
            let data = {
              text: item.Email,
              value: item.Email,
            };
            result.push(data);
          });
          this.emailList = result;
          this.$bus.$emit(emit, true);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    onShowEmit(index, emit) {
      if (!this.isEdit) {
        return;
      }
      this.itemIndex = index;
      this.$bus.$emit(emit, true);
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    loadWayBillInfo() {
      this.$commonMethod.showLoading();
      var param = {
        CompanyId: this.CompanyId,
        WB_Number: this.WB_Number,
        WGId: this.WGId,
        TOId: this.TOId,
      };
      this.$api.logisticsManagement
        .loadWayBillInfo(param)
        .then((res) => {
          this.billInfo = res.data;
          this.$commonMethod.fieldRefresh(".billsReceivable");
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    onSubmit() {
      var AccountList = [];
      if (this.selectedAccountList.length > 0) {
        this.selectedAccountList.forEach((item) => {
          AccountList.push(item.AccountId);
        });
      }
      var param = {
        CompanyId: this.CompanyId,
        UserId: this.UserId,
        CustomerId: this.customerInfoSelect.value,
        InvoiceNo: this.billInfo.InvoiceNo,
        PWB_Number: this.billInfo.PWB_Number,
        WB_Number: this.billInfo.WB_Number,
        Remark: this.form.Remark,
        ItemList: this.form.itemList,
        AccountList: AccountList,
      };
      var request = null;
      if (this.InvoiceNo) {
        param.CB_Id = this.billInfo.CB_Id;
        request = this.$api.logisticsManagement.editCollectionBill(param);
      } else if (this.TOId) {
        param.TOId = this.TOId;
        request = this.$api.logisticsManagement.addCollectionBill(param);
      } else if (this.WGId) {
        param.WGId = this.WGId;
        request = this.$api.logisticsManagement.addCollectionBill(param);
      } else {
        request = this.$api.logisticsManagement.addCollectionBill(param);
      }
      this.$commonMethod.showLoading();
      request
        .then(() => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.operateSuccess,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    getCurrencyList() {
      return new Promise((resolve) => {
        this.$api.financialManagement
          .getSystemAvailableCurrencyList()
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.CurrencySn,
                value: item.SCId,
              };
              result.push(data);
            });
            this.currencyList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getBillPaymentList() {
      return new Promise((resolve) => {
        this.$api.financialManagement
          .getBillPaymentListByCompanyId()
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.ItemName,
                value: item.BillId,
              };
              result.push(data);
            });
            this.billPaymentList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getCollectionAccountInfoList() {
      return new Promise((resolve) => {
        this.$api.financialManagement
          .getCollectionAccountInfoList({
            CompanyId: this.CompanyId,
            IsEnable: 1,
            PageIndex: 0,
            PageSize: 1000,
          })
          .then((res) => {
            var result = [];
            res.data.Data.forEach((item) => {
              let data = {
                text: item.AccountNickName,
                value: item.AccountId,
                BankName: item.BankName,
                AccountNumber: item.AccountNumber,
                SwiftCode: item.SwiftCode,
                Address: item.Address,
              };
              result.push(data);
            });
            this.accountInfoList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    gotoPrint() {
      for (var key in this.form.itemList) {
        if (!this.form.itemList[key].BillId) {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.billsReceivable.selectBill,
            type: "error",
          });
          return false;
        }
      }

      var accountList = [];
      if (this.selectedAccountList.length > 0) {
        this.selectedAccountList.forEach((item) => {
          accountList.push({
            AccountNickName: item.AccountNickName,
            AccountName: item.AccountName,
            BankName: item.BankName,
            AccountNumber: item.AccountNumber,
            SwiftCode: item.SwiftCode,
            Address: item.Address,
          });
        });
      }

      var itemList = [];
      for (var item of this.form.itemList) {
        if (item.BillId) {
          var billItem = this.billPaymentList.find((c) => c.value == item.BillId);
          itemList.push({
            Item: billItem ? billItem.text : item.BillName,
            Currency: parseInt(item.Currency),
            Quantity: parseFloat(item.Quantity),
            UnitPrice: item.UnitPrice,
            Total: item.Rate,
          });
        }
      }

      var param = {
        FileType: 2,
        IsReturnBase64str: 1,
        CompanyId: this.CompanyId,
        InvoiceNo: this.billInfo.InvoiceNo,
        PWB_Number: this.billInfo.PWB_Number,
        WB_Number: this.billInfo.WB_Number,
        CustomerName: this.customerInfoSelect.text,
        CustomerNumber: this.customerInfoSelect.CustomerNumber,
        Remark: this.form.Remark,
        POL: this.billInfo.POL,
        POD: this.billInfo.POD,
        EtdDate: this.billInfo.EtdDate,
        AllWeight: this.billInfo.AllWeight,
        ItemList: itemList,
        AccountList: accountList,
      };
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "base64Print",
        name: "base64Print",
        query: [
          {
            name: "Api",
            value: "createCollectionBillPdf",
          },
          {
            name: "Param",
            value: JSON.stringify(param),
          },
        ],
      });
    },
    dialogShowEmail() {
      for (var key in this.form.itemList) {
        if (!this.form.itemList[key].BillId) {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.billsReceivable.selectBill,
            type: "error",
          });
          return false;
        }
      }
      this.emailVisible = true;
    },
    onSendEmail() {
      this.$commonMethod.showLoading();

      var accountList = [];
      if (this.selectedAccountList.length > 0) {
        this.selectedAccountList.forEach((item) => {
          accountList.push({
            AccountNickName: item.AccountNickName,
            AccountName: item.AccountName,
            BankName: item.BankName,
            AccountNumber: item.AccountNumber,
            SwiftCode: item.SwiftCode,
            Address: item.Address,
          });
        });
      }

      var itemList = [];
      for (var item of this.form.itemList) {
        if (item.BillId) {
          itemList.push({
            Item: item.ItemName,
            Currency: parseInt(item.Currency),
            Quantity: parseFloat(item.Quantity),
            UnitPrice: item.UnitPrice,
            Total: item.Rate,
          });
        }
      }

      var param = {
        Email: this.emailForm.email,
        CompanyId: this.CompanyId,
        InvoiceNo: this.billInfo.InvoiceNo,
        PWB_Number: this.billInfo.PWB_Number,
        WB_Number: this.billInfo.WB_Number,
        CustomerName: this.customerInfoSelect.text,
        CustomerNumber: this.customerInfoSelect.CustomerNumber,
        Remark: this.form.Remark,
        POL: this.billInfo.POL,
        POD: this.billInfo.POD,
        EtdDate: this.billInfo.EtdDate,
        AllWeight: this.billInfo.AllWeight,
        ItemList: itemList,
        AccountList: accountList,
      };
      this.$api.logisticsManagement
        .getCollectionBillSharingEmail(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.emailVisible = false;
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.billsReceivable {
  ::v-deep .van-field--disabled {
    .van-field__label,
    .van-field__control {
      color: #999 !important;
      -webkit-text-fill-color: #999 !important;
    }
  }

  ::v-deep .number-label {
    line-height: 33px;
  }

  .item-button {
    padding: 6px 8px;
    height: auto;

    ::v-deep .van-button__text {
      font-size: 12px !important;
    }
  }

  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }

  .van-cell::after {
    border: none !important;
  }

  .avatarImg {
    width: 50px;
    height: 50px;
  }

  .multi-table {
    .multi-table-header {
      padding: 10px 15px;
      background: #1e90ff;
      .multi-table-title {
        font-size: 14px;
        font-family: monospace;
        color: #fff;
        width: 50%;
        display: inline-block;
        vertical-align: middle;
      }

      .multi-table-btn {
        width: 50%;
        display: inline-block;
        text-align: right;
        vertical-align: middle;
        .van-icon {
          font-size: 20px;
          font-weight: bold;
          color: #fff;
        }
      }
    }
  }

  .billsReceivable-alert {
    overflow: scroll;
    height: 100vw;
    margin-top: 30px;
    margin-bottom: 30px;

    .multi-table {
      .multi-table-header {
        padding: 10px 15px;

        .multi-table-title {
          font-size: 14px;
          color: #999;
          display: inline-block;
          vertical-align: middle;
        }

        .multi-table-btn {
          font-size: 20px;
          color: #000;
          width: 100%;
          display: inline-block;
          text-align: right;
          vertical-align: middle;
        }
      }
    }
  }

  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);

    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
